import { useCallback, useEffect, useState } from 'react';
import { getUserAgent } from '../../utils/getUserAgent.js';
const useIsWebView = () => {
    const [isWebView, setIsWebView] = useState(false);
    const isWebViewApp = useCallback(() => {
        const userAgent = getUserAgent();
        if (userAgent.includes('webview')) {
            setIsWebView(true);
        }
        else {
            setIsWebView(false);
        }
    }, []);
    useEffect(() => {
        isWebViewApp();
    }, [isWebViewApp]);
    return isWebView;
};
export default useIsWebView;
//# sourceMappingURL=index.js.map